module.exports = __webpack_public_path__ + "static/images/details-2.06e395b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/ssk/details-2.png
// module id = ktLM
// module chunks = 0